import { useTheme } from "@emotion/react";
import { PeopleAltOutlined } from "@mui/icons-material";
import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
export default function CardAllAnswers(params) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const {
    value = 0,
    colorCard,
    colorIcon = theme.palette.colors.blue.light,
    icon: Icon = null,
    title = "Total de respostas",
    descricao = "Respostas",
  } = params;

  return (
    <Paper
      variant="outlined"
      sx={{
        ...styles.paperContainer,
        background: colorCard,
      }}
    >
      <Box sx={styles.boxContainer}>
        <Typography sx={{ color: theme.palette.white.main }}>
          {" "}
          {title}:
        </Typography>
        <Box
          sx={{
            ...styles.containerIcon,
            backgroundColor: colorIcon,
          }}
        >
          {Icon && <Icon sx={styles.icon} />}
        </Box>
      </Box>
      <Box sx={styles.containerValue}>
        <Typography
          sx={{
            ...styles.value,
            color: theme.palette.white.main,
          }}
        >
          {value}
        </Typography>
        <Typography sx={styles.descricao}>{descricao}</Typography>
      </Box>
    </Paper>
  );
}
